import EventHandler from '@pixelunion/events';
import Disclosure from '@pixelunion/shopify-cross-border';
import { transition } from '@pixelunion/animations';

export default class Footer {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.headings = this.el.querySelectorAll('[data-toggle-content]');
    this.events = new EventHandler();

    // Currency and Language selectors
    this.currencyDisclosureEl = this.el.querySelector('[data-disclosure-currency]');
    this.localeDisclosureEl = this.el.querySelector('[data-disclosure-locale]');
    this.disclosures = [];

    if (this.currencyDisclosureEl) {
      this.disclosures.push(new Disclosure(this.currencyDisclosureEl));
    }

    if (this.localeDisclosureEl) {
      this.disclosures.push(new Disclosure(this.localeDisclosureEl));
    }

    this.headings.forEach(heading => {
      const parent = heading.parentNode;
      const content = parent.querySelector('[data-content]');
      const animateContent = transition({ el: content, state: 'closed' });
      this.events.register(heading, 'click', () => {
        this.toggleContent(parent, animateContent);
      });
    });
  }

  toggleContent(parent, animateContent) {
    if (parent.classList.contains('active')) {
      animateContent.animateTo('closed');
      parent.classList.remove('active');
    } else {
      animateContent.animateTo('open');
      parent.classList.add('active');
    }
  }

  onSectionUnload() {
    this.events.unregisterAll();
    this.disclosures.forEach(disclosure => disclosure.unload());
  }
}
